import React from 'react';
import { Collapse, Row, Col, Table, Input, Spinner, Label } from 'reactstrap';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { t } from '../common/Translate';
import { useDevinDecoding } from '../../hooks/usePricing/useDevinDecoding';
import VinDecodingEquipmentsModal from '../common/equipment/VinDecodingEquipmentsModal';
import { Record } from '../../config/Record/RecordEntity';
import useRecord from '../../Store/uses/useRecord';

function VinDecoding({
  vinVersions,
  checkedVinVersions,
  vinVersionsOpen,
  versionType,
  versions,
  currentVersion,
  versionSupplier,
  versionOrg,
  carEquipment,
}) {
  const { loading, quotaionVersions, isOpenEquipments, setIsOpenEquipments } = useDevinDecoding(
    versions,
    versionType,
    currentVersion,
  );
  const { recordId } = useParams();
  const { record } = useRecord(recordId);
  const recordEntity = new Record(record);
  return (
    <Collapse isOpen={vinVersionsOpen}>
      {versionType === 'vin' && loading ? (
        <>
          <Spinner color="primary" size="sm" type="grow" className="ml-2" />
          <Spinner color="primary" size="sm" type="grow" className="ml-2" />
          <Spinner color="primary" size="sm" type="grow" className="ml-2" />
        </>
      ) : (
        <Row>
          <div className="accordion-body w-100">
            <Col xs={12} sm={12} md={12} lg={12}>
              {versionOrg && (
                <div className="mb-2">
                  <small>
                    <span className="text-lightgray font-weight-bold"> VIN-identified version : </span>
                    <span className="h6">{` ${versionOrg}`}</span>
                  </small>
                </div>
              )}
              {versionSupplier && (
                <div className="mb-2">
                  <small>
                    <span className="text-lightgray font-weight-bold"> Source : </span>
                    <span className="h6">
                      {` ${versionSupplier.toLowerCase() === 'dat' ? 'external' : 'Manufacturer'}`}
                    </span>
                  </small>
                </div>
              )}
              <div className="mb-2">
                <small className="text-lightgray mb-2">
                  {t('Possible versions (autobiz):')}
                  <span className="font-weight-bold">
                    {
                      (
                        quotaionVersions ||
                        (versionType === 'vin' && versions.length > 0 ? versions : vinVersions) ||
                        []
                      ).length
                    }
                  </span>
                </small>
              </div>
              <Table className="border border-dark">
                <thead>
                  <tr className="btn-primary">
                    <th style={{ width: isMobile ? '2rem' : '4rem' }}> </th>
                    <th>{t('Version')}</th>
                    <th className="text-center">{t('B2CValue')}</th>
                    <th className="text-center">{t('TotalStock')}</th>
                  </tr>
                </thead>
                <tbody>
                  {(
                    quotaionVersions ||
                    (versionType === 'vin' && versions.length > 0 ? versions : vinVersions) ||
                    []
                  ).map((version) => (
                    <tr className="border-bottom border-dark">
                      <th scope="row" className="d-flex justify-content-center align-center">
                        <Input
                          type="radio"
                          value={version.id}
                          checked={version.selected === true}
                          className="ml-0"
                          onClick={(e) => checkedVinVersions(e)}
                        />
                      </th>
                      <td>
                        <small className="font-weight-bold">{version?.name}</small>
                      </td>
                      <td className="text-center">
                        {version?.quotation?._quotation || version?.quotation?._quotation?.b2cMarketValue === 0
                          ? version?.quotation?._quotation?.b2cMarketValue
                          : ''}
                      </td>
                      <td className="text-center">
                        {version?.quotation?._marketInformation &&
                          Number(version?.quotation?._marketInformation.nbrAdsOfParticular || 0) +
                            Number(version?.quotation?._marketInformation.nbrAdsOfNetwork || 0) +
                            Number(version?.quotation?._marketInformation.nbrAdsOfOtherPro || 0)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {!!carEquipment?.length > 0 && !recordEntity.isNrmRecord() && (
                <Col lg={12} className="w-100">
                  <Label>&nbsp;</Label>
                  <button
                    type="button"
                    className="btn btn-3 btn-block seeHistovecInfo m-auto"
                    onClick={() => setIsOpenEquipments(true)}
                  >
                    {t('seeEquipement')}
                  </button>
                </Col>
              )}
            </Col>
          </div>
          {!!carEquipment?.length && !recordEntity.isNrmRecord() && (
            <VinDecodingEquipmentsModal
              isOpen={isOpenEquipments}
              setIsOpen={setIsOpenEquipments}
              equipments={carEquipment || []}
            />
          )}
        </Row>
      )}
    </Collapse>
  );
}

VinDecoding.propTypes = {
  vinVersions: PropTypes.oneOfType([PropTypes.array]),
  checkedVinVersions: PropTypes.func.isRequired,
  vinVersionsOpen: PropTypes.bool.isRequired,
  versions: PropTypes.oneOfType([PropTypes.array]).isRequired,
  versionType: PropTypes.string.isRequired,
  currentVersion: PropTypes.number.isRequired,
  versionSupplier: PropTypes.string,
  versionOrg: PropTypes.string,
  carEquipment: PropTypes.oneOfType([PropTypes.array]).isRequired,
};

VinDecoding.defaultProps = {
  vinVersions: null,
  versionSupplier: null,
  versionOrg: null,
};
export default VinDecoding;
